import { ApiRequest } from "../apiRequest";

const ALLOWED_DIVISIONS = [
  {
    id: "digital-marketing",
    name: "Digital Marketing",
    keyword: "digital marketing",
  },
  {
    id: "product-marketing",
    name: "Product Marketing",
    keyword: "product marketing",
  },
  {
    id: "event-activation",
    name: "Event Activation",
    keyword: "event activation",
  },
];

/**
 * Fetch semua role dari API
 */
export const fetchAllRoles = async () => {
  try {
    const res = await ApiRequest({
      url: "/roles/all?limit=100",
      method: "GET",
    });

    if (res.status === "success") {
      return res.data || [];
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch roles:", error);
    return [];
  }
};

/**
 * Mengelompokkan role berdasarkan divisi.
 *
 * Contoh:
 * Digital Marketing
 * Digital Marketing Manager
 * SPV Digital Marketing
 * Staff Digital Marketing
 *
 * semuanya masuk ke Digital Marketing.
 */
export const getDelegationDivisions = (roles = []) => {
  return ALLOWED_DIVISIONS.map((division) => {
    const matchedRoles = roles.filter((role) =>
      role.name?.toLowerCase().includes(division.keyword),
    );

    return {
      id: division.id,
      name: division.name,
      roleIds: matchedRoles.map((role) => role.user_role_id),
    };
  });
};
